import React from 'react';
import { track } from '../../utils/analytics';
import LandingPropertyStory from './LandingPropertyStory';

export default function LandingHero({ editorial = false }) {
  return (
    <section className="section hero hero-property-story" id="top">
      <div className="hero-bg" aria-hidden="true" />
      <div className="container">
        <div className="hero-grid">
          {/* LEFT: editorial copy */}
          <div className="hero-copy">
            <div className="vert-badge reveal d1">
              <span>Your Australian property advocate. On your side.</span>
            </div>
            <h1 className="reveal d2">
              An agent that thinks <span className="em">in property.</span>
            </h1>
            <p className="lede reveal d3">
              {editorial ? <>A clearer plan. A closer look at every property. Help with the purchase and what comes after—shaped around you.</> : <>Heyward is a <strong>self-learning AI agent</strong> built end-to-end for Australian property investors and first home buyers
              {' , '}
              goal to strategy, research to acquisition, ownership to management. One throughline. One memory. Real numbers.</>}
            </p>
            <div className="hero-ctas reveal d4">
              <a className="btn btn-primary btn-lg" href="/sign-up" onClick={() => track.waitlistCtaClicked('hero')}>
                Start free <span className="arr" aria-hidden="true">→</span>
              </a>
              <a className="btn btn-ghost btn-lg" href="#strategy">See how it works <span className="arr" aria-hidden="true">↓</span></a>
            </div>
            <div className="hero-trust reveal d5">
              <div>
                <div className="ts-num">12<small>yrs</small></div>
                <div className="ts-lbl">of Australian property data, end-to-end</div>
              </div>
              <div>
                <div className="ts-num">30<small>suburbs</small></div>
                <div className="ts-lbl">with forensic depth + volatility</div>
              </div>
              <div>
                <div className="ts-num">6.1<small>%</small></div>
                <div className="ts-lbl">mean offer-pricing error · initial 9-sale sample</div>
              </div>
            </div>
          </div>

          <LandingPropertyStory editorial={editorial} />
        </div>
      </div>
    </section>
  );
}
